module.exports = __webpack_public_path__ + "img/empty.7ac16750.svg";